import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Day } from 'lumen/models';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';

interface TypeSpecificData {
  reason: string;
}

export default class Recommendation extends Model {
  [Type] = 'marketing/recommendation' as const;

  @hasMany('day', { async: false, inverse: 'marketingRecommendations' })
  declare days: HasMany<Day>;

  @attr('hoteldate') declare endDate: NonNullable<HoteldateTransformReturn>;
  @attr('hoteldate') declare fromDate: NonNullable<HoteldateTransformReturn>;
  @attr('string') declare type: string;
  @attr() declare typeSpecificData: TypeSpecificData;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isSingleDay() {
    return this.fromDate.isSame(this.endDate, 'day');
  }
}
